import type { ReactNode } from "react";
import { Link } from "react-router";
import { Compass } from "lucide-react";
import { useDocumentTitle } from "../../app/useDocumentTitle.js";
import { paths } from "../../app/paths.js";
import { EmptyState, buttonClass } from "../../ui/primitives.js";

export function NotFoundPage(): ReactNode {
  useDocumentTitle("Nicht gefunden");
  return (
    <div className="flex min-h-[70dvh] items-center justify-center px-6">
      <EmptyState
        icon={Compass}
        title="Diese Seite gibt es nicht"
        action={
          <Link to={paths.dashboard} className={buttonClass("primary")}>
            Zur Übersicht
          </Link>
        }
      >
        Der Link ist veraltet oder falsch. Über die Navigation oder die Suche findest du alles.
      </EmptyState>
    </div>
  );
}
